export default "__VITE_ASSET__A$2S86U1__"